import type { BackendModule, Resource } from 'i18next';
import type { AppSupportedLanguageTag } from '@/lib/locale/constants';
import { APP_SUPPORTED_LANGUAGE_TAGS } from '@/lib/locale/constants';
import { arResources } from '@/locales/ar';
import { deDEResources } from '@/locales/de-DE';
import { enAUResources } from '@/locales/en-AU';
import { enGBResources } from '@/locales/en-GB';
import { enUSResources, type EnUSResources } from '@/locales/en-US';
import { esESResources } from '@/locales/es-ES';
import { frFRResources } from '@/locales/fr-FR';

/** One bundle per supported BCP-47 tag (shape matches `en-US` namespaces). */
const PACKS: Record<AppSupportedLanguageTag, EnUSResources> = {
  ar: arResources as unknown as EnUSResources,
  'en-US': enUSResources,
  /** UK/AU English use distinct copy; `as const` literals differ from en-US so we cast to the canonical shape. */
  'en-GB': enGBResources as unknown as EnUSResources,
  'en-AU': enAUResources as unknown as EnUSResources,
  'de-DE': deDEResources as unknown as EnUSResources,
  'fr-FR': frFRResources as unknown as EnUSResources,
  'es-ES': esESResources as unknown as EnUSResources,
};

export function buildI18nResourcesForSupportedLanguages(): Resource {
  const out: Resource = {};
  for (const lng of APP_SUPPORTED_LANGUAGE_TAGS) {
    out[lng] = PACKS[lng] as unknown as Resource[string];
  }
  return out;
}

/** Native bundles every pack; the web build (registerI18nResources.web.ts) loads the translated ones on demand. */
export const i18nLanguageBackend: BackendModule | null = null;
